//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import GTM from '~/utils/classes/Gtm'
import { isWindow } from '~/plugins/v-js'

export default {
  name: 'FavoriteButton',
  props: {
    boatId: {
      type: Number,
      default: 0
    },
    onlyIcon: {
      type: Boolean,
      default: false
    },
    iconType: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      gtm: new GTM(this.$gtm),
      iconTypes: {
        default: ['fa-heart', 'far-heart'],
        favorite: ['v2-close', 'v2-close']
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      favorites: 'auth/favorites'
    }),
    getIcon: app => (value) => {
      const icons = app.iconTypes[app.iconType || 'default'] || app.iconTypes.default
      return value ? icons[0] : icons[1]
    },
    getText () {
      if (this.onlyIcon) {
        return ''
      }
      return this.isFavorited ? this.$t('remove-from-favorite') : this.$t('add-to-favorite')
    },
    getFavorites () {
      return {
        id: this.boatId,
        state: !!this.favorites.find(item => parseInt(item.id, 10) === parseInt(this.boatId, 10))
      }
    },
    isFavorited () {
      return !!this.getFavorites.state
    }
  },
  methods: {
    async favorite () {
      const addToFavorite = async () => {
        const req = await this.$store.dispatch('auth/favorite', { boat_id: this.boatId, user_id: this.user.id })
        if (req) {
          this.successHandler()
        }
      }

      if (this.user) {
        await addToFavorite()
      } else {
        await this.$store.dispatch('addCallback', {
          name: 'favorite-after-login',
          when: 'after',
          target: 'login',
          data: {},
          callback: addToFavorite
        })
        this.$modal.show('login-modal')
        this.$emit('onLoginRequested')
      }
    },
    async unfavorite () {
      const req = await this.$store.dispatch('auth/unfavorite', { boat_id: this.boatId, user_id: this.user.id })
      if (req) {
        this.successHandler()
      }
    },
    successHandler () {
      this.activateScript()
    },
    activateScript () {
      this.gtm.setCustomTag({ event: 'custom_favorite' })

      if (isWindow()) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'Favorite A Boat',
          eventCategory: 'Favorite',
          eventAction: 'Click on Heart',
          eventLabel: 'Favorite Boat ' + this.boatId
        })
      }
    }
  }
}
